import { create } from 'zustand'

interface AuthUiState {
  authModalOpen: boolean
  /** 'panel' = opened from the account panel, 'save' = user hit Save Route,
   *  'suggestion' = user chose "Log in" from the road-suggestion email match */
  reason: 'panel' | 'save' | 'suggestion'
  openAuthModal: (reason: 'panel' | 'save' | 'suggestion') => void
  closeAuthModal: () => void
  /** Bumped by the "Your Routes" buttons to open the saved-routes list. */
  routesSeq: number
  openRoutes: () => void
  /** Bumped after a successful sign-in that started from the Suggest-a-Road
   *  login prompt, so the suggestion panel reopens without the prompt. */
  suggestReopenSeq: number
  reopenSuggest: () => void
}

export const useAuthUi = create<AuthUiState>((set) => ({
  authModalOpen: false,
  reason: 'panel',
  openAuthModal: (reason) => set({ authModalOpen: true, reason }),
  closeAuthModal: () => set({ authModalOpen: false }),
  routesSeq: 0,
  openRoutes: () => set((s) => ({ routesSeq: s.routesSeq + 1 })),
  suggestReopenSeq: 0,
  reopenSuggest: () => set((s) => ({ suggestReopenSeq: s.suggestReopenSeq + 1 })),
}))
